import { Images } from '@/assets/images';
import {
	DocTypeEnum,
	DocumentTypeEnum,
	EOccuringAreaEnum,
	PageTypeEnum,
	ReasonDetailIndex,
	ReasonDetailTypeEnum,
	ReasonIndex,
	ReasonTypeEnum,
	REGEX,
	ResidenceEnum,
	ResidenceLabel,
} from '@/constant';
import {
	cn,
	convertVisaCodeToName,
	formatDate,
	insertObjectIfV2,
} from '@/utils';

import { range } from 'ramda';

import { FormConfig } from '../define-document-write.type';

export const REPORT_CONTENTS = [
	ReasonTypeEnum.TERMINATION,
	ReasonTypeEnum.DEATH,
	ReasonTypeEnum.ABSENT_WITHOUT_PERMISSION,
	ReasonTypeEnum.WORKPLACE_INFO_CHANGE,
	ReasonTypeEnum.EMPLOYMENT_SUCCESSOR,
	ReasonTypeEnum.BRANCH_TRANSFER,
	ReasonTypeEnum.WORKER_DEPLOYMENT,
	ReasonTypeEnum.OTHER,
];

export const OCCURING_AREAS = [
	EOccuringAreaEnum.BUSINESS_PLACE,
	EOccuringAreaEnum.ACCOMMODATION,
	EOccuringAreaEnum.OTHER,
];

export const REQUEST_DOCUMENTS = [
	'death certificate',
	'disease/injury certificate',
	'labor contract',
	'resignation letter',
	'other',
];

export const LIST_REPORT_FORM_CHANGE_REPORT = [
	{ id: 0, value: '', label: '' },
	{ id: 1, value: 'a', label: 'a' },
	{ id: 3, value: 'b', label: 'b' },
	{ id: 4, value: 'c', label: 'c' },
	{ id: 5, value: 'd', label: 'd' },
	{ id: 6, value: 'e', label: 'e' },
	{ id: 7, value: 'f', label: 'f' },
	{ id: 8, value: 'g', label: 'g' },
	{ id: 9, value: 'h', label: 'h' },
];

export const LIST_REASON_REPORT_FORM_CHANGE_REPORT = [
	{ id: 0, value: '', label: '' },
	{ id: 1, value: '1', label: '1' },
	{ id: 2, value: '2', label: '2' },
	{ id: 3, value: '3', label: '3' },
	{ id: 4, value: '4', label: '4' },
	{ id: 5, value: '5', label: '5' },
	{ id: 6, value: '6', label: '6' },
	{ id: 7, value: '7', label: '7' },
	{ id: 8, value: '8', label: '8' },
	{ id: 9, value: '9', label: '9' },
	{ id: 10, value: '10', label: '10' },
	{ id: 11, value: '11', label: '11' },
	{ id: 12, value: '12', label: '12' },
	{ id: 13, value: '13', label: '13' },
	{ id: 14, value: '14', label: '14' },
	{ id: 15, value: '15', label: '15' },
	{ id: 16, value: '16', label: '16' },
	{ id: 17, value: '17', label: '17' },
];

const initializeValue = {
	receptionNum: '',
	receptionDate: '',
	processingTime: '',
	insuranceWorkplaceMngNum: '',
	businessRegisNo: '',
	franchiseName: '',
	franchisePhone: '',
	franchiseFaxNumber: '',
	franchisePhoneNum: '',
	franchiseEmail: '',
	reportContent: '',
	reasonOrOther: '',
	occuringArea: '',
	occuringAreaOther: '',
	workerPhoneNumber: '',
	specifyReason: '',
	workplaceBeforeChange: '',
	workplaceAfterChange: '',
	recruitChangeFormJson: range(0, 5).map((item) => ({
		id: item.toString(),
		workerNameEnglish: '',
		alienRegistNo: '',
		sojournStatus: '',
		dateOfOccurence: '',
		reasonOfReport: '',
		reasonOfReportDetail: '',
	})),
	reportCreateDate: '',
	reporterName: '',
	reporterSignature: '',
	dearToText: '',
	requestDocument: '',
	requestDocumentOther: '',
	requestUserName: '',
	requestUserSignature: '',
	declarantName: '',
};

type IValues = typeof initializeValue;

export const EMPLOYMENT_CHANGE_REPORT_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.WC1_05
> = {
	initializeValue,
	mapPropToValues({
		refTableName,
		detailData,
		franchiseData,
		applicantData,
		applicantListData,
		documentType,
	}) {
		const { workerUnauthorizedDeparture, workerChangeWorkPlaceDetail } =
			detailData;
		if (
			refTableName === PageTypeEnum.APPLICANT ||
			refTableName === PageTypeEnum.FRANCHISE
		) {
			const newApplicantListData = [...(applicantListData || [])];

			if (
				applicantData.id &&
				!newApplicantListData?.some((item) => item.id === applicantData.id)
			) {
				newApplicantListData?.unshift({
					...applicantData,
				});
			}

			if (newApplicantListData?.length) {
				newApplicantListData?.forEach((item) => {
					item.visaCode = (ResidenceLabel[item?.visaCode as ResidenceEnum] ||
						(null as unknown)) as ResidenceEnum;
				});
			}

			const createRecruitChangeForm = (index: number) => ({
				id: index.toString(),
				workerNameEnglish: newApplicantListData[index]?.fullName || '',
				alienRegistNo: newApplicantListData[index]?.foreignerNo || '',
				sojournStatus: newApplicantListData[index]?.visaCode || '',
				dateOfOccurence: '',
				reasonOfReport: '',
				reasonOfReportDetail: '',
			});

			return {
				reportContent:
					documentType === DocumentTypeEnum.C_63
						? ReasonTypeEnum.ABSENT_WITHOUT_PERMISSION
						: ReasonTypeEnum.TERMINATION,
				reasonOrOther:
					documentType === DocumentTypeEnum.C_75
						? `${applicantData?.midTermDepartureFull
							? `중도 출국 (${applicantData?.midTermDepartureFull})`
							: ''
						}`
						: '',
				recruitChangeFormJson: range(0, 5).map(createRecruitChangeForm),
				businessRegisNo: franchiseData?.employerBirthDate
					? `${formatDate(franchiseData?.employerBirthDate, { outputFormat: 'YYMMDD' })}-`
					: '',
				franchiseName: franchiseData?.employerName || '',
				franchisePhone: franchiseData?.employerPhone || '',
				franchisePhoneNum: franchiseData?.employerPhone || '',
				franchiseEmail: franchiseData?.email || '',
			};
		}

		if (refTableName === PageTypeEnum.CHANGE_WORK_PLACE) {
			const createRecruitChangeForm = (index: number) => ({
				id: index.toString(),
				workerNameEnglish:
					index === 0
						? applicantData.fullName
							? applicantData.fullName
							: workerChangeWorkPlaceDetail?.applicantName
						: applicantListData?.[index - 1]?.fullName || '',
				alienRegistNo:
					index === 0
						? applicantData.fullName
							? applicantData.foreignerNo
							: workerChangeWorkPlaceDetail?.applicantForeignerNo
						: applicantListData?.[index - 1]?.foreignerNo || '',
				sojournStatus:
					index === 0
						? applicantData.visaCode
							? convertVisaCodeToName(applicantData.visaCode)
							: workerChangeWorkPlaceDetail?.applicationVisaCodeName
						: ResidenceLabel[
						applicantListData?.[index - 1]?.visaCode as ResidenceEnum
						] || '',
				dateOfOccurence:
					index === 0 ? workerChangeWorkPlaceDetail?.assignmentDate : '',
				reasonOfReport:
					index === 0
						? ReasonIndex[
						workerChangeWorkPlaceDetail?.reason as ReasonTypeEnum
						] || ''
						: '',
				reasonOfReportDetail:
					index === 0
						? workerChangeWorkPlaceDetail?.reason === ReasonTypeEnum.TERMINATION
							? ReasonDetailIndex[
							workerChangeWorkPlaceDetail?.detailReason as ReasonDetailTypeEnum
							]
							: ''
						: '',
			});

			return {
				reportContent: workerChangeWorkPlaceDetail?.reason || '',
				...insertObjectIfV2(
					workerChangeWorkPlaceDetail?.reason === ReasonTypeEnum.TERMINATION,
					{
						reasonOrOther:
							ReasonDetailIndex[
							workerChangeWorkPlaceDetail?.detailReason as ReasonDetailTypeEnum
							] || '',
					}
				),
				businessRegisNo: workerChangeWorkPlaceDetail?.prevEmployerBirthDate
					? `${formatDate(workerChangeWorkPlaceDetail?.prevEmployerBirthDate, { outputFormat: 'YYMMDD' })}-`
					: '',
				franchiseName: workerChangeWorkPlaceDetail?.prevEmployerName || '',
				franchisePhone: workerChangeWorkPlaceDetail?.prevEmployerPhone || '',
				franchisePhoneNum: workerChangeWorkPlaceDetail?.prevEmployerPhone || '',
				franchiseEmail: workerChangeWorkPlaceDetail?.prevEmail || '',
				recruitChangeFormJson: range(0, 5).map(createRecruitChangeForm),
			};
		}

		if (refTableName === PageTypeEnum.UNAUTHORIZED_DEPARTURE) {
			const createRecruitChangeForm = (index: number) => ({
				id: index.toString(),
				workerNameEnglish:
					index === 0
						? applicantData.fullName
							? applicantData.fullName
							: workerUnauthorizedDeparture?.applicantName
						: applicantListData?.[index - 1]?.fullName || '',
				alienRegistNo:
					index === 0
						? applicantData.fullName
							? applicantData.foreignerNo
							: workerUnauthorizedDeparture?.applicantForeignerNo
						: applicantListData?.[index - 1]?.foreignerNo || '',
				sojournStatus:
					index === 0
						? applicantData.visaCode
							? convertVisaCodeToName(applicantData.visaCode)
							: workerUnauthorizedDeparture?.applicationVisaCodeName
						: ResidenceLabel[
						applicantListData?.[index - 1]?.visaCode as ResidenceEnum
						] || '',
				dateOfOccurence:
					index === 0 ? workerUnauthorizedDeparture?.occuringDate : '',
				reasonOfReport:
					index === 0 ? ReasonTypeEnum.ABSENT_WITHOUT_PERMISSION : '',
				reasonOfReportDetail: '',
			});

			return {
				reportContent: ReasonTypeEnum.ABSENT_WITHOUT_PERMISSION,
				occuringArea: workerUnauthorizedDeparture?.occuringArea || '',
				...insertObjectIfV2(
					workerUnauthorizedDeparture?.occuringArea === EOccuringAreaEnum.OTHER,
					{
						occuringAreaOther:
							workerUnauthorizedDeparture?.occuringAreaDetail || '',
					}
				),
				workerPhoneNumber: applicantData?.phone || '',
				specifyReason: workerUnauthorizedDeparture?.reason || '',
				businessRegisNo: franchiseData?.employerBirthDate
					? `${formatDate(franchiseData?.employerBirthDate, { outputFormat: 'YYMMDD' })}-`
					: '',
				franchiseName: workerUnauthorizedDeparture?.franchiseName || '',
				franchisePhone: workerUnauthorizedDeparture?.franchisePhone || '',
				franchisePhoneNum: workerUnauthorizedDeparture?.franchisePhone || '',
				franchiseEmail: workerUnauthorizedDeparture?.franchiseEmail || '',

				recruitChangeFormJson: range(0, 5).map(createRecruitChangeForm),
			};
		}

		return {};
	},
	title: '고용변동신고서',
	pages: [
		{
			background: {
				src: Images.formEmploymentChangeReportFrontSideHighlight,
				className: 'template',
				dataSource: Images.formEmploymentChangeReportFrontSide,
			},
			textAreas: [
				{
					name: 'receptionNum',
					maxHeight: 28,
					maxLength: 20,
					containerClassName: 'absolute top-[156px] left-[130px] w-[104px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					className: 'leading-4',
				},
				{
					name: 'insuranceWorkplaceMngNum',
					maxHeight: 20,
					maxLength: 24,
					containerClassName: 'absolute top-[231px] left-[160px] w-[185px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'businessRegisNo',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[231px] left-[354px] w-[175px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'franchiseName',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[231px] left-[540px] w-[175px]',
				},
				{
					name: 'franchisePhone',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[265px] left-[205px] w-[250px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'franchiseFaxNumber',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[265px] left-[463px] w-[250px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'franchisePhoneNum',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[301px] left-[206px] w-[250px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'franchiseEmail',
					maxHeight: 30,
					maxLength: 25,
					containerClassName: 'absolute top-[286px] left-[538px] w-[182px]',
					className: 'leading-4',
				},

				(data, index) => ({
					name: 'reasonOrOther',
					maxHeight: 16,
					containerClassName: cn(
						'absolute hidden bg-transparent',
						data?.reportContent === ReasonTypeEnum.TERMINATION &&
						'block top-[361px] left-[220px] w-[500px]',
						data?.reportContent === ReasonTypeEnum.OTHER &&
						'block top-[439px] left-[532px] w-[145px]',
						data?.reasonOrOther && 'bg-white'
					),
					maxLength: 63,
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),
				(data, index) => ({
					name: 'occuringAreaOther',
					maxHeight: 20,
					containerClassName: cn(
						'absolute invisible top-[476px] left-[390px]',
						data.occuringArea === EOccuringAreaEnum.OTHER && 'visible'
					),
					maxLength: 10,
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				}),

				{
					name: 'workerPhoneNumber',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[491px] left-[267px] w-[250px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'specifyReason',
					maxHeight: 20,
					maxLength: 35,
					containerClassName: 'absolute top-[506px] left-[283px] w-[400px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'workplaceBeforeChange',
					maxHeight: 20,
					maxLength: 40,
					containerClassName: 'absolute top-[543px] left-[185px] w-[440px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'workplaceAfterChange',
					maxHeight: 20,
					maxLength: 40,
					containerClassName: 'absolute top-[559px] left-[184px] w-[440px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},

				(data, index) => ({
					jsonKey: 'recruitChangeFormJson',
					name: 'workerNameEnglish',
					repeat: 5,
					maxHeight: 24,
					maxLength: 40,
					containerClassName: 'absolute text-center left-[197px] w-[113px]',
					'data-tabIndex': index,
					boxStyle: {
						top: `${644 + 22 * index}px`,
					},
					style: { fontSize: 8, lineHeight: '10px' },
				}),

				(data, index) => ({
					jsonKey: 'recruitChangeFormJson',
					name: 'alienRegistNo',
					repeat: 5,
					maxHeight: 24,
					maxLength: 14,
					containerClassName: 'absolute left-[315px] w-[106px]',
					'data-tabIndex': index,
					boxStyle: {
						top: `${645 + 22 * index}px`,
					},
					style: { fontSize: 12 },
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				}),
				(data, index) => ({
					jsonKey: 'recruitChangeFormJson',
					name: 'sojournStatus',
					repeat: 5,
					maxHeight: 24,
					maxLength: 5,
					containerClassName: 'absolute left-[427px] w-[45px]',
					'data-tabIndex': index,
					boxStyle: {
						top: `${645 + 22 * index}px`,
					},
					style: { fontSize: 12 },
				}),
				(data, index) => ({
					jsonKey: 'recruitChangeFormJson',
					name: 'dateOfOccurence',
					repeat: 5,
					maxHeight: 24,
					maxLength: 10,
					style: { fontSize: 12 },
					boxStyle: {
						top: `${645 + 22 * index}px`,
					},
					containerClassName: 'absolute left-[474px]',
					'data-tabIndex': index,
				}),
				(data, index) => ({
					name: 'dearToText',
					maxHeight: 16,
					maxLength: 6,
					containerClassName: cn(
						'absolute top-[804px] left-[49px] w-[91px]',
						data?.dearToText && 'bg-white'
					),
					className: 'text-right',
					regex: REGEX.ALLOW_KR_SPACE,
				}),
				(data, index) => ({
					name: 'requestDocumentOther',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: cn(
						'absolute hidden bg-transparent top-[899px] left-[234px] w-[271px]',
						data?.requestDocument === REQUEST_DOCUMENTS[4] && 'block'
					),
				}),
				{
					name: 'declarantName',
					maxHeight: 20,
					maxLength: 5,
					containerClassName: 'absolute top-[786px] left-[510px] w-[90px]',
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'requestUserName',
					maxHeight: 20,
					maxLength: 5,
					containerClassName: 'absolute top-[1019px] left-[422px]',
					regex: REGEX.ALLOW_KR_EN,
				},
			],
			checkboxes: [
				{
					name: 'reportContent',
					options: REPORT_CONTENTS,
					classNames: [
						'absolute top-[345px] left-[174px] w-[14px] h-[14px]',
						'absolute top-[379px] left-[174px] w-[14px] h-[14px]',
						'absolute top-[379px] left-[459px] w-[14px] h-[14px]',
						'absolute top-[398px] left-[174px] w-[14px] h-[14px]',
						'absolute top-[417px] left-[174px] w-[14px] h-[14px]',
						'absolute top-[417px] left-[459px] w-[14px] h-[14px]',
						'absolute top-[437px] left-[174px] w-[14px] h-[14px]',
						'absolute top-[437px] left-[459px] w-[14px] h-[14px]',
					],
					iconType: 'circle',
					iconClassName: 'w-4 h-4',
					getResetKey: (value: string) => {
						return ['reasonOrOther'];
					},
				},
				{
					name: 'occuringArea',
					options: OCCURING_AREAS,
					classNames: [
						'absolute top-[477px] left-[204px] w-[14px] h-[14px]',
						'absolute top-[477px] left-[278px] w-[14px] h-[14px]',
						'absolute top-[477px] left-[340px] w-[14px] h-[14px]',
					],
					iconType: 'circle',
					iconClassName: 'w-4 h-4',
				},
				{
					name: 'requestDocument',
					options: REQUEST_DOCUMENTS,
					classNames: [
						'absolute top-[890px] left-[179px] w-[14px] h-[14px]',
						'absolute top-[890px] left-[266px] w-[14px] h-[14px]',
						'absolute top-[890px] left-[386px] w-[14px] h-[14px]',
						'absolute top-[890px] left-[473px] w-[14px] h-[14px]',
						'absolute top-[900px] left-[179px] w-[14px] h-[14px]',
					],
					iconType: 'circle',
					iconClassName: 'w-4 h-4',
					getResetKey: (value: string) => {
						return ['requestDocumentOther'];
					},
				},
			],
			signatures: [
				{
					name: 'reporterName',
					className: 'absolute w-[70px] h-[30px] top-[788px] left-[649px]',
				},

				{
					name: 'requestUserSignature',
					className: 'absolute w-[117px] h-[50px] top-[1005px] left-[596px]',
				},
			],
			datePickers: [
				{
					name: 'receptionDate',
					className: 'w-[116px] [&>.ant-picker-input>input]:!text-xs',
					containerClassName: 'absolute top-[158px] left-[297px]',
					style: { marginTop: -7, fontSize: 13 },
				},
				{
					name: 'processingTime',
					className: 'w-[116px] [&>.ant-picker-input>input]:!text-xs',
					containerClassName: 'absolute top-[158px] left-[600px]',
					style: { marginTop: -7, fontSize: 13 },
				},

				{
					name: 'reportCreateDate',
					segmentedInputs: true,
					format: 'YYYY                MM              DD',
					style: { fontSize: '13px' },
					boxStyle: { marginTop: '-7px' },
					containerClassName: 'absolute top-[778px] left-[540px]',
				},
			],
			selects: [
				(data, index) => ({
					repeat: 5,
					jsonKey: 'recruitChangeFormJson',
					name: 'reasonOfReport',
					containerClassName: 'absolute left-[579px]',
					boxStyle: {
						top: `${643 + 22 * index}px`,
					},
					options: LIST_REPORT_FORM_CHANGE_REPORT,
					'data-tabIndex': index,
					className: 'w-[47px] select select-1',
					resetKeys: ['reasonOfReportDetail'],
				}),
				(data, index) => ({
					repeat: 5,
					jsonKey: 'recruitChangeFormJson',
					name: 'reasonOfReportDetail',
					containerClassName: 'absolute left-[628px]',
					boxStyle: {
						top: `${643 + 22 * index}px`,
					},
					options: LIST_REASON_REPORT_FORM_CHANGE_REPORT,
					'data-tabIndex': index,
					className: cn(
						'w-[88px]',
						data?.recruitChangeFormJson?.[index]?.reasonOfReport ===
							LIST_REPORT_FORM_CHANGE_REPORT[1]?.value
							? ' cursor-pointer'
							: ''
					),
					disabled:
						data?.recruitChangeFormJson?.[index]?.reasonOfReport !==
						LIST_REPORT_FORM_CHANGE_REPORT[1]?.value,
				}),
			],
		},
		{
			background: {
				src: Images.formEmploymentChangeReportBackSide,
			},
		},
	],
};
